module.exports = __webpack_public_path__ + "static/img/qq_img_4.04de50c1.png";